import { Formatter } from '@/filters/formatter'
import { Options, TooltipFormatterContextObject } from 'highcharts'

export const StatisticalAnalysisViewDetailChartTypeChartsFactoryBarRadial: Options = {
    chart: {
        type: 'column',
        inverted: true,
        polar: true
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            borderWidth: 0,
            pointPadding: 0,
            groupPadding: 0.15
        }
    },
    pane: {
        size: '100%',
        innerSize: '10%',
        endAngle: 270
    },
    xAxis: {
        tickInterval: 1,
        labels: {
            align: 'right',
            step: 1,
            y: 3
        },
        lineWidth: 0
    },
    yAxis: {
        crosshair: {
            width: 1,
            color: '#666'
        },
        lineWidth: 0,
        reversedStacks: false,
        endOnTick: true,
        title: {
            text: '',
            align: 'middle',
            textAlign: 'right',
            x: -45,
            y: 75
        }
    },
    tooltip: {
        useHTML: true,
        formatter: function() {
            const context: TooltipFormatterContextObject = this
            return `
                <span>${context.x}</span><br>
                <span style="color:${context.color}">${context.series.name}</span>: <b> ${Formatter.number(context.y)}</b><br/>`
        }
    }
}
